import { isVAOnHelpCenterGAEnabled } from '@helpcenter/feature-flags';
import { getMeta } from '@helpcenter/meta';
import ViewHomepageQuery from 'view/advanced-help-center/view-homepage/__generated__/viewHomepageQuery.graphql';
import type { viewHomepageQuery } from 'view/advanced-help-center/view-homepage/__generated__/viewHomepageQuery.graphql';
import type { viewHomepageForCsmQuery } from 'view/customer-service/view-homepage/__generated__/viewHomepageForCsmQuery.graphql';
import ViewHomepageForCsmQuery from 'view/customer-service/view-homepage/__generated__/viewHomepageForCsmQuery.graphql';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { isCSMHelpCenter } from '@atlassian/help-center-common-util/advanced-help-center';
import { getEnv } from '@atlassian/help-center-common-util/env';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router/resource-router';
import type { searchLoaderVirtualAgentEnabledV2Query } from '../../../help-center/search/src/__generated__/searchLoaderVirtualAgentEnabledV2Query.graphql';
import SearchLoaderVirtualAgentEnabledV2Query from '../../../help-center/search/src/__generated__/searchLoaderVirtualAgentEnabledV2Query.graphql';

export const ViewHomepageResource = isCSMHelpCenter(getEnv().helpCenterType)
    ? createRelayResource<viewHomepageForCsmQuery>({
          type: 'VIEW_HOMEPAGE',
          getQuery: (_, { cloudId, helpCenterAri, layoutAri }) => {
              return {
                  parameters: ViewHomepageForCsmQuery,
                  variables: {
                      cloudId,
                      helpCenterAri,
                      layoutAri,
                      filter: { isEditMode: false },
                  },
                  options: {
                      fetchPolicy: 'store-or-network',
                  },
              };
          },
      })
    : createRelayResource<viewHomepageQuery>({
          type: 'VIEW_HOMEPAGE',
          getQuery: (_, { cloudId, helpCenterAri, layoutAri }) => {
              return {
                  parameters: ViewHomepageQuery,
                  variables: {
                      cloudId,
                      helpCenterAri,
                      layoutAri,
                      filter: { isEditMode: false },
                  },
                  options: {
                      fetchPolicy: 'store-or-network',
                  },
              };
          },
      });

export const searchComponentVirtualAgentResource = createRelayResource<searchLoaderVirtualAgentEnabledV2Query>({
    type: 'HELP_CENTER_SEARCH_VIRTUAL_AGENT',
    getQuery: (_, { cloudId, helpCenterAri, isUserLoggedIn }) => {
        const isLoggedIn = FeatureGates.checkGate('jsd-search-router-login-logic-removal')
            ? Boolean(getMeta('ajs-atlassian-account-id'))
            : isUserLoggedIn;
        return {
            parameters: SearchLoaderVirtualAgentEnabledV2Query,
            variables: {
                cloudId,
                helpCenterAri,
                isVaOnHcGAEnabled: isVAOnHelpCenterGAEnabled() && isLoggedIn,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
